import styled from "styled-components";
import { Box, Link } from "@mui/material";
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import { ChevronRight } from "@mui/icons-material";

export const BoxBreadCrumbs = styled(Box)(
  ({ theme }: {theme: typeof DefaultUptimeTheme}) => `
  padding: 0;
  .MuiBreadcrumbs-separator{
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
  }
  display: flex;
  align-items: center;
  gap: 51px;
`
);

export const StyledLink = styled(Link)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  text-decoration: none !important;
`
);

export const StyledSeperator = styled(ChevronRight)(
  ({ theme }) => `
  width: 20px !important;
  height: 24px !important;
`
);